import React, { useContext, useEffect, useState } from 'react'
import { Context } from '../../../config/store';
import Modal from '../../../components/Modal';
import LenderUgroService from '../../../services/lender';
import { toast } from "react-toastify";

const ChangeCLMType = () => {
    const { state, dispatch } = useContext(Context);
    const [loading, setLoading] = useState(false);
    const [lafIds, setLafIds] = useState('')
    const [responseData, setResponseData] = useState('')
    const [showConfirmationModal, setShowConfirmationModal] = useState(false)
    useEffect(() => {
        dispatch({
            type: 'selectedColender',
            selectedColender: `/portfolio/clmtype`,
        });
        localStorage.setItem('selectedColender', `/portfolio/clmtype`);
    }, []);

    const handleSubmit = async () => {
        let lafs = lafIds.split(',')
        try {
            setLoading(true);
            const response = await LenderUgroService.convertClmtype({
                "laf_ids": lafs
            });
            toast.success(response?.data?.messages?.success?.others[0])
            let resData = response.data.data;
            setResponseData(resData)
            setLoading(false);
            setShowConfirmationModal(false);
        } catch (err) {
            setLoading(false);
            setShowConfirmationModal(false);
            toast.error(
                err.response?.data?.messages?.error?.fields[0] ||
                err.response?.data?.messages?.error?.form[0] ||
                err.response?.data?.messages?.error?.others[0]
            );
        }
    }

    const handleConfirmationModal = () => {
        if (lafIds.length <= 0) {
            toast.error("Please input atleast one LAF to convert")
        }else{
            setShowConfirmationModal(true)
        }
    }

    const resetFilter = () => {
        setLafIds('')
    }

    return (
        <>
        <div>
            <div className="chart-card mb-3">
                <div className="row">
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label>LAF IDs </label>
                            <textarea
                                name="lafIds"
                                rows={5}
                                cols={80}
                                placeholder="Add multiple LAF IDs by comma seperated!"
                                style={{ resize: 'none', padding: '5px' }}
                                value={lafIds}
                                onChange={(e) => setLafIds(e.target.value.replace(/[^a-zA-Z0-9,]/g, "").trim())}
                                maxLength={250}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 d-flex'>
                        <button
                            onClick={handleConfirmationModal}
                            type='button'
                            disabled={loading}
                            className='btn btn-custom viewBtn mr-1'
                            id='submitButton'
                        >
                            {!loading ? 'Submit' : <div className="loader"></div>}
                        </button>
                        <button
                            onClick={resetFilter}
                            type='button'
                            className='btn btn-custom viewBtn'
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
            {Object.entries(responseData).length ?
                <div className="globalSearchContainer">
                    <div className='px-2 subHeaderbar w-100' style={{ marginBottom: '0px' }}>
                        <div>Conversion Report  :</div>
                    </div>
                    {Object.entries(responseData || {}).map((item, index) => {
                        return (
                            <div className="row px-2 clm-type-block">
                                <div className="col-md-4 d-flex justify-content-start align-items-center my-1">
                                    <div className="detailsRightLabel" style={{'white-space': 'nowrap'}}>
                                        LAF ID :
                                    </div>
                                    <div className="detailsRightValue ml-1" style={{'word-wrap': 'break-word', 'overflow': 'auto'}}>
                                        {item[0]}
                                    </div>
                                </div>
                                <div className="col-md-8 d-flex justify-content-start align-items-center my-1">
                                    <div className="detailsRightLabel">
                                        Status :
                                    </div>
                                    <div className="detailsRightValue ml-1" style={{'word-wrap': 'break-word', 'overflow': 'auto'}}>
                                        {item[1]}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                :
                null
            }
        </div>
        <Modal state={showConfirmationModal} style={{ width: "370px" }} removeBorderSpace={true}>
                <div className="modal-header-container">
                    {/* <div className="modal-title">Attention</div>
                    <div className="closeModalView" onClick={()=>setShowConfirmationModal(false)}>
                        <span className="closeModalIcon">x</span>
                    </div> */}
                </div>
                <div className="p-4">
                    <div>
                        <div class='form-group'>
                            <label>Do you want to change the CLM type (Option1 to Option2)?</label>
                        </div>
                        <div class='d-flex align-items-center justify-content-center mt-3'>
                            <button type='button' class='btn btn-custom' disabled={loading} onClick={handleSubmit}>
                                {loading ? <div className='loader' /> : 'OK'}
                            </button>
                            <button
                                type='button'
                                class='btn btn-outline-custom ml-2'
                                data-dismiss='modal'
                                onClick={()=>setShowConfirmationModal(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default ChangeCLMType